@if (price.price) {
  <div class="product-price clearfix price-1 {{ scheme }}">
    <div class="price full-width">
      <p>
        @if (price.title) {
          <span>{{ price.title }}</span>
        }
        {{ price.price }}
      </p>
    </div>
    @if (listing.price_terms) {
      <p class="definition">
        {{ listing.price_terms }}
      </p>
    }
  </div>
}
